import { useTranslation } from "react-i18next";
import { useModuleEnabled } from "../../../redux/selectors/modules";
import { setOverrideModule, unsetOverrideModule } from "../../../redux/reducers/overrideModulesReducer";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { Flex } from "../../../../styled-system/jsx";
import { css } from "../../../../styled-system/css";

const DashboardSelector = () => {
  const { t } = useTranslation(["advertising"]);
  const hasOldDashboardModule = useModuleEnabled("ADS_V1");
  const user = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();

  return (
    <Flex
      className={css({
        border: "1px solid #c0c0c0",
        width: "100%",
        margin: 0,
        padding: "medium",
        color: "#fff",
        fontSize: "small",
        backgroundColor: "#9D7EB8",
      })}
      gap={"medium"}
      justifyContent={"center"}
    >
      {hasOldDashboardModule ?
        <>
          {t(($) => $.advertising["Try out the new Advertising dashboard!"])}{" "}
          <span
            className={css({ cursor: "pointer", color: "#fff", textDecoration: "underline" })}
            onClick={() => {
              dispatch(unsetOverrideModule({ orgId: user.organization_id, module: "ADS_V1" }));
            }}
          >
            {t(($) => $.advertising["View the new dashboard"])}
          </span>
        </>
      : <>
          {t(($) => $.advertising["Revert to the old Advertising dashboard"])}{" "}
          <span
            className={css({ cursor: "pointer", color: "#fff", textDecoration: "underline" })}
            onClick={() => {
              dispatch(setOverrideModule({ orgId: user.organization_id, module: "ADS_V1" }));
            }}
          >
            {t(($) => $.advertising["View the original dashboard"])}
          </span>
        </>
      }
    </Flex>
  );
};

export default DashboardSelector;
